import { Box, useTheme } from '@mui/material';
import React from 'react';
import ArrowBackground from 'v2/assets/vector/ArrowBackground';
import TKHSecurityLogo from 'v2/assets/vector/TKHSecurityLogo';
import TKHSecurityLogoDark from 'v2/assets/vector/TKHSecurityLogoDark';

export interface Props {
  id?: string;
  withLogo?: boolean;
}

const Background: React.FC<React.PropsWithChildren<Props>> = ({ id, withLogo = true, children }) => {
  const theme = useTheme();

  return (
    <Box
      id={id}
      sx={{
        position: 'relative',
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.default
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          overflow: 'hidden',
          pointerEvents: 'none'
        }}
      >
        {withLogo && (
          <Box sx={{ position: 'absolute', top: '40px', left: '40px' }}>
            {theme.palette.mode === 'light' ? (
              <TKHSecurityLogo sx={{ height: 40, width: 106 }} />
            ) : (
              <TKHSecurityLogoDark sx={{ height: 40, width: 106 }} />
            )}
          </Box>
        )}
        <Box sx={{ position: 'absolute', bottom: 0, right: 0 }}>
          <ArrowBackground
            sx={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              height: {
                xs: '100vh',
                lg: 'auto'
              },
              width: {
                xs: 'auto',
                lg: '30vw'
              }
            }}
          />
        </Box>
      </Box>
      <Box sx={{ position: 'relative' }}>{children}</Box>
    </Box>
  );
};

export default Background;
